
<div class="siteWrapper">
    <app-header *ngIf="authService.isLoggedIn()"></app-header>
    <router-outlet />

    <app-footer *ngIf="authService.isLoggedIn()"></app-footer>
    <app-booking-popup></app-booking-popup>
    <div class="recaptcha-container" id="recaptcha-container"></div>
</div>
<div class="mobileSoon" *ngIf="isMobile">
    <img class="portr" src="mobile-version-coming-soon.jpg" alt="">
    <img class="landsc" src="mobile-version-coming-soon-landscape.jpg" alt="">
</div>

